<template>
    <div>
        <div class="modal-top-summary">
            <div class="modal-top-summary__data --course">
                <slot name="name" />
            </div>
            <div class="modal-top-summary__data">
                <span class="modal-top-summary__title" v-html="$t('OrganizationReport.completed')"></span>
                <span class="modal-top-summary__amount"><slot name="completed" /></span>
            </div>
            <div class="modal-top-summary__data">
                <span class="modal-top-summary__title" v-html="$t('OrganizationReport.uncompleted')"></span>
                <span class="modal-top-summary__amount"><slot name="uncompleted" /></span>
            </div>
            <div class="modal-top-summary__data">
                <span class="modal-top-summary__title" v-html="$t('OrganizationReport.total_watched')"></span>
                <span class="modal-top-summary__amount"><slot name="totalWatched" /></span>
            </div>
            <div v-if="$totemLang !== 'dk'" class="modal-top-summary__data">
                <span class="modal-top-summary__title" v-html="$t('OrganizationReport.authorization')"></span>
                <slot name="authorizations" />
            </div>
        </div>
        <slot name="categories" />
    </div>
</template>

<script>
    export default {
        name: 'modal-top-summary'
    }
</script>

<style lang="scss">
.modal-top-summary {
    display: flex;
    font-family: PlusJakartaSans-Regular, sans-serif;
    font-size: 1.6rem;
    color: $tuatara;

    &__data {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;

        &.--course {
            align-items: flex-start;
            gap: 3px;
        }
    }

    &__title {
        font-family: PlusJakartaSans-Bold, sans-serif;
        font-size: 1.8rem;
        display: flex;
        margin: 0 0 20px;
    }

    &__amount {
        font-family: Nunito-ExtraBold, sans-serif;
        font-size: 2rem;
    }

    &__details-label {
        font-family: Nunito-ExtraBold, sans-serif;
        font-size: 1.6rem;
        line-height: 1.8rem;
        color: $emperor;
        margin: 0 5px 0 0;
    }

    &__details-data {
        line-height: 1.8rem;
        position: relative;
        margin-right: 5px;

        &:not(:last-of-type) {
            &:after {
                content: ',';
                position: absolute;
                right: 0;
            }
        }
    }

    &__badge {
        font-size: 1.4rem;
        border-radius: 20px;
        padding: 7px 18px;
        background: $light_orange;
        margin: 0 0 4px;
        line-height: 12px;
        display: flex;
        align-items: center;
    }

}
</style>
